export default __webpack_public_path__ + "static/media/backend.e9214b0c.cdz";